<ng-template vdrDialogTitle>{{ "order.export-b2b-invoices" | translate }}</ng-template>

<div style="width: 100%; min-width: 320px">
  <label class="mt-2">{{ "common.format" | translate }}</label>

  <div style="display: flex; gap: 1rem; margin: 1rem 0">
    <clr-radio-wrapper>
      <input
        type="radio"
        clrRadio
        name="b2b-format"
        value="xlsx"
        [checked]="format === 'xlsx'"
        (change)="setFormat('xlsx')"
      />
      <label>XLSX</label>
    </clr-radio-wrapper>
    <clr-radio-wrapper>
      <input
        type="radio"
        clrRadio
        name="b2b-format"
        value="pdf"
        [checked]="format === 'pdf'"
        (change)="setFormat('pdf')"
      />
      <label>PDF</label>
    </clr-radio-wrapper>
  </div>

  <p>
    {{
      "order.b2b-export-summary"
        | translate
          : {
              count: total
            }
    }}
  </p>

  <!-- BUILD MARKER — remove after deploy verification -->
  <p style="color: #999; font-size: 11px; margin-top: 0.5rem">
    [build 2026-08-21]
  </p>
</div>

<ng-template vdrDialogButtons>
  <button type="button" class="btn" (click)="cancel()">
    {{ "common.cancel" | translate }}
  </button>
  <button type="submit" (click)="save()" class="btn btn-primary">
    {{ "common.okay" | translate }}
  </button>
</ng-template>
